import moment from 'moment'
import * as CONST from 'Reducers/Ambassador/const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'
import * as INV_CONST from 'Reducers/Inventory/const'
import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'
import { MISSION_STATUS_ENUM } from '../../shared/constants'

const initState = {
  ambassadorById: { isLoading: false },
  ambassadorDocumentsById: [],
  ambassadorInventoryById: [],
  ambassadorInventoryClients: [],
  ambassadorsByCityId: [],
  clientId: null,
  ambassadorsByCityIdStatusFilter: CONST.AMBASSADOR_STATUS[0].value,
  ambassadorsByCityIdSearchValue: '',
  ambassadorsByCityIdSortBy: {
    columnName: null,
    reverse: false,
  },
  inventoryByClientIdSortBy: {
    columnName: null,
    reverse: false,
  },
  activitiesSortBy: {
    columnName: null,
    reverse: false,
  },
  activityStatus: CONST.ACTIVITY_STATUS.ALL,
  ambassadorActivitiesById: [],
  // Has map of ambassador ids to ambassadors, newly added so most likely
  // not in use for most requests
  ambassadors: {},
}

const mapBrandAmbassador = ambassador => {
  const haveMissions = Array.isArray(ambassador.missions.edges)
  const missions = haveMissions
    ? ambassador.missions.edges.map(({ node }) => node)
    : []
  const completedStatuses = [
    MISSION_STATUS_ENUM.COMPLETED,
    MISSION_STATUS_ENUM.UNDER_REVIEW,
    MISSION_STATUS_ENUM.PAID,
  ]
  const completedMissions = missions.filter(m =>
    completedStatuses.includes(m.status),
  )

  const futureMissionsCount = ambassador.futureMissions
    ? ambassador.futureMissions.totalCount
    : missions.filter(m => {
        return (
          m.status == MISSION_STATUS_ENUM.CHECKED_IN ||
          (m.status == MISSION_STATUS_ENUM.BOOKED &&
            new Date(m.dateTime) > new Date())
        )
      }).length

  const completedMissionsDates = missions.map(m => moment(m.dateTime)) //TODO: use checkout time
  const firstCompletedMissionTime = completedMissionsDates.length
    ? moment.min(completedMissionsDates)
    : null
  const lastCompletedMissionTime = completedMissionsDates.length
    ? moment.max(completedMissionsDates)
    : null

  const isNewcomer =
    firstCompletedMissionTime &&
    moment().diff(firstCompletedMissionTime, 'week') < 1

  const status =
    ambassador.status === CONST.AMBASSADOR_STATUS_KEY.BLOCKED &&
    futureMissionsCount > 0
      ? CONST.AMBASSADOR_STATUS_KEY.TERMINATING
      : ambassador.status

  const signedLegalDocuments = (
    (ambassador.signedLegalDocuments || {}).edges || []
  ).map(e => ({
    dateTime: e.node.dateTime,
    ...e.node.legalDocument,
  }))

  return {
    ...ambassador,
    isNewcomer,
    lastMissionDate: lastCompletedMissionTime
      ? lastCompletedMissionTime.format()
      : null,
    missionCompletedCount: completedMissions.length,
    missionCount: missions.length,
    missionsReviewedCount: missions.filter(m => m.rating !== null).length,
    memberSince: moment(parseInt(ambassador.memberSince, 10)).format(),
    missions,
    status,
    signedLegalDocuments,
  }
}

export function ambassadors(state = initState, action) {
  switch (action.type) {
    case CONST.RESSET_AMBASSADOR_DATA:
      return {
        ...initState,
      }
    case CONST.GET_AMBASSADOR_BY_ID_SUCCESS:
      return {
        ...state,
        ambassadorById: action.payload.ambassadorById,
      }
    case CONST.GET_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS: {
      return {
        ...state,
        ambassadorById: mapBrandAmbassador(action.result.data.brandAmbassador),
      }
    }
    case CONST.UPDATE_AMBASSADOR_BY_ID:
      return {
        ...state,
        ambassadorById: {
          ...state.ambassadorById,
          // TODO At some point we should probably solve the inconsistency
          // between the server returning camelCase and the update endpoint
          // requiring underscore case
          withholdPay:
            action.payload.withhold_pay == undefined
              ? state.ambassadorById.withholdPay
              : action.payload.withhold_pay,
          fixedPriceMissions:
            action.payload.fixedPriceMissions == undefined
              ? state.ambassadorById.fixedPriceMissions
              : action.payload.fixedPriceMissions,
          extendedMissionsLimit:
            action.payload.extended_missions_limit == undefined
              ? state.ambassadorById.extendedMissionsLimit
              : action.payload.extended_missions_limit,
        },
      }
    case CONST.UPDATE_AMBASSADOR_BY_ID_GRAPH_QL:
      return {
        ...state,
        ambassadorById: {
          ...state.ambassadorById,
          isLoading: true,
        },
      }

    case CONST.UPDATE_AMBASSADOR_BY_ID_GRAPH_QL_SUCCESS:
      return {
        ...state,
        ambassadorById: {
          ...state.ambassadorById,
          ...action.payload.ambassadorById,
          isLoading: false,
        },
      }

    case CONST.UPDATE_AMBASSADOR_BY_ID_GRAPH_QL_ERROR:
      return {
        ...state,
        ambassadorById: {
          ...state.ambassadorById,
          isLoading: false,
        },
      }

    case CONST.GET_AMBASSADOR_DOCUMENTS_BY_ID_SUCCESS:
      return {
        ...state,
        ambassadorDocumentsById: action.payload.ambassadorDocumentsById,
      }

    case CONST.GET_AMBASSADORS_BY_CITY_ID_SUCCESS:
      return {
        ...state,
        ambassadorsByCityId: action.payload.ambassadorsByCityId,
      }
    case CONST.GET_AMBASSADORS_BY_CITY_ID_GRAPH_QL_SUCCESS:
      return {
        ...state,
        ambassadorsByCityId: action.result.data.brandAmbassadors.edges.map(
          ({ node }) => mapBrandAmbassador(node),
        ),
      }
    case CONST.SET_INVENTORY_BY_CLIENT_ID_SORT_BY:
      return {
        ...state,
        inventoryByClientIdSortBy: action.inventoryByClientIdSortBy,
      }

    case CONST.SET_ACTIVITIES_SORT_BY:
      return {
        ...state,
        activitiesSortBy: action.activitiesSortBy,
      }

    case CONST.SET_INVENTORY_BY_CLIENT_ID:
      return {
        ...state,
        clientId: action.payload.clientId,
      }

    case CONST.SET_ACTIVITY_FILTER_STATUS:
      return {
        ...state,
        activityStatus: action.payload.status,
      }

    case CONST.GET_AMBASSADOR_ACTIVITIES_SUCCESS:
      return {
        ...state,
        ambassadorActivitiesById: action.payload.ambassadorActivitiesById,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        ambassadorsByCityIdStatusFilter:
          initState.ambassadorsByCityIdStatusFilter,
        ambassadorsByCityIdCarryingFilter:
          initState.ambassadorsByCityIdCarryingFilter,
        ambassadorsByCityIdSearchValue:
          initState.ambassadorsByCityIdSearchValue,
      }

    case INV_CONST.GET_INVENTORY_ITEM_SUCCESS:
      let newUsers = {}
      action.result.data.inventoryItem.movements.nodes
        .map(m => m.relatedUser)
        .filter(u => u)
        .forEach(u => (newUsers[u.id] = u))

      return {
        ...state,
        ambassadors: {
          ...state.ambassadors,
          ...newUsers,
        },
      }

    case INV_CONST.LOAD_INVENTORY_SUCCESS:
      let newUsers2 = {}
      action.result.data.inventoryItems.edges.forEach(edge => {
        const node = edge.node
        node.movementsV2.nodes.forEach(m => {
          if (m.relatedUser) {
            newUsers2[m.relatedUser.id] = m.relatedUser
          }
        })
      })
      return {
        ...state,
        ambassadors: {
          ...state.ambassadors,
          ...newUsers2,
        },
      }

    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS: {
      return {
        ...state,
        ambassadors: {
          ...(() => {
            var users = {}
            var cityPlans = action.result.data.campaign.cityPlans.nodes
            cityPlans.forEach(cityPlan => {
              cityPlan.city.brandAmbassadors.edges.forEach(({ node }) => {
                users[node.id] = node
              })
            })
            return users
          })(),
        },
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Ambassador/reducer.js